/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { BranchCostAppraisalPaginationResponseDto } from '../model/branchCostAppraisalPaginationResponseDto';
import { BranchCostAppraisalRequestDto } from '../model/branchCostAppraisalRequestDto';
import { BranchCostAppraisalResponseDto } from '../model/branchCostAppraisalResponseDto';
import { ValidationError } from '../model/validationError';

export enum branchCostAppraisalsGetStatusEnum {
  draft = 'draft',
  active = 'active',
  in_active = 'in_active',
}
export enum branchCostAppraisalsIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class BranchCostAppraisalsService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public branchCostAppraisalsActiveIdPost$(id: string): Observable<string> {
    return this.api.post(`${apiBaseUrl()}/branch-cost-appraisals/active/${encodeURIComponent(String(id))}`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchCostAppraisalsGet$(page?: number, limit?: number, branchId?: string, status?: string, beginEffectiveDate?: string, endEffectiveDate?: string, sort?: string): Observable<BranchCostAppraisalPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branch-cost-appraisals`, { page, limit, branchId, status, beginEffectiveDate, endEffectiveDate, sort });
  }
  /**
   * [Authorize] type: http
   */
  public branchCostAppraisalsIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/branch-cost-appraisals/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchCostAppraisalsIdGet$(id: string, language?: string): Observable<BranchCostAppraisalResponseDto> {
    return this.api.get(`${apiBaseUrl()}/branch-cost-appraisals/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public branchCostAppraisalsIdPut$(id: string, body: BranchCostAppraisalRequestDto): Observable<BranchCostAppraisalResponseDto> {
    return this.api.put(`${apiBaseUrl()}/branch-cost-appraisals/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public branchCostAppraisalsPost$(body: BranchCostAppraisalRequestDto): Observable<BranchCostAppraisalResponseDto> {
    return this.api.post(`${apiBaseUrl()}/branch-cost-appraisals`, body, undefined);
  }
}
